import { muted } from './admin.css'
import type { useResolvedAdminUser } from './useResolvedAdminUser'

type AdminUserResolutionHintProps = {
  state: ReturnType<typeof useResolvedAdminUser>
}

export function AdminUserResolutionHint({ state }: AdminUserResolutionHintProps) {
  if (!state.query) {
    return null
  }
  if (state.lookup.isLoading && (state.isEmailQuery || state.isUserIdQuery)) {
    return <span className={muted}>Validando usuário...</span>
  }
  if (state.lookup.isError) {
    return <span className={muted}>Falha ao consultar o usuário. Tente novamente.</span>
  }
  if (state.notFound) {
    return <span className={muted}>Nenhum usuário encontrado para esse e-mail.</span>
  }
  return null
}
